<template>
	<section>
		<!--工具条-->		
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item label="开始时间">
					<el-date-picker
						v-model="filters.entimes"
						value-format="yyyy-MM-dd"
						style="width:100%"
						 type="date"
						 placeholder="选择日期"
					   />
				</el-form-item>
				<el-form-item label="结束时间">
					<el-date-picker
						v-model="filters.entimee"
						value-format="yyyy-MM-dd"
						style="width:100%"
						 type="date"
						 placeholder="选择日期"
					   />
				</el-form-item>
				<el-form-item>
					<el-select 
						v-model="filters.site" filterable placeholder="选择站点" class="h-m-select">
					  <el-option v-for="item in service_options"
						:key="item.sites_id" :label="item.sites" v-model="item.sites_id">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-checkbox v-model="filters.showtime">显示时间</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-checkbox v-model="filters.showsite">显示Site</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button v-if="filters.toXls" type="primary" @click="downXls">生成下载XLS</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:95%;" height="500"
			:summary-method="formatXxfUp" show-summary>
			<el-table-column label="----" min-width="30" v-if="filters.noShowColTable"></el-table-column>
			<el-table-column prop="date" label="Daily" min-width="60" v-if="filters.showtimeTable"></el-table-column>
			<el-table-column prop="alis_index" label="site" min-width="100" v-if="filters.showsiteTable">
				<template slot-scope="scope">
					<div>
						{{scope.row.alis_index+"--"+scope.row.site}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="requests" label="请求数" min-width="60"></el-table-column>
			<el-table-column prop="pp_requests" label="填充数" min-width="60"></el-table-column>
			<el-table-column prop="fill_rate" label="覆盖率(%)" min-width="60"></el-table-column>
			<el-table-column prop="imp" label="展示" min-width="60"></el-table-column>
			<el-table-column prop="click" label="点击" min-width="60"></el-table-column>
			<el-table-column prop="ctr" label="CTR(%)" min-width="60"></el-table-column>
			<el-table-column prop="publisher_cpc" label="CPC" min-width="60"></el-table-column>
			<el-table-column prop="publisher_cpm" label="ECPM" min-width="60"></el-table-column>
			<el-table-column prop="net_revenue" label="分成前收益" min-width="80"></el-table-column>
			<el-table-column prop="publisher_revenue" label="分成后收益" min-width="80"></el-table-column>
		</el-table>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					entimes:'',
					entimee:'',
					codes:'',
					site:'',
					showtime:true,
					showtimeTable:true,
					showsite:true,
					showsiteTable:true,
					noShowColTable:false,
					showspinfo:false,
					showcpinfo:false,
					toXls:false
				},
				datalist: [],
				tgsList:[],
				service_options:[],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				timer:null, //定时器名称
			}
		},
		methods: {
			downXls:function(){
				let paras = "api/datas/cpQueryXls?entimes="+this.filters.entimes+"&entimee="+this.filters.entimee+"&site="+this.filters.site;
				//console.log(paras);
				window.open(paras);
			},
			getServiceList(){
				let para = {
					actionurl:'datas/getMySites'
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.service_options = res.data.datas;
						this.filters.toXls = res.data.toXls ;
					}
				});
				
			},
			getLists:function(){
				let para = {
					entimes:this.filters.entimes,
					entimee:this.filters.entimee,
					codes:this.filters.codes,
					service_code:this.filters.site,
					actionurl:'datas/getLists'
				};
				
				if(this.filters.showtime){
					para.showtime = 1 ;
				}
				if(this.filters.showsite){
					para.showsite = 1 ;
				}
				
				this.listLoading = true;
				//NProgress.start();
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.filters.showtimeTable = this.filters.showtime ;
						this.filters.showsiteTable = this.filters.showsite;
						if(res.data.isOneThis){
							this.filters.showspinfo = true;
							this.filters.showcpinfo = true;
						}else{
							this.filters.showspinfo = false;
							this.filters.showcpinfo = false;
						}
						console.log(">>>"+this.filters.showspinfo);
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					
					this.listLoading = false;
					//NProgress.done();
				});
			},
			formatXxfUp: function (param) {
				const { columns, data } = param;
				const sums = [];
				var noSumIndex = -1 ;
				if(this.filters.showtimeTable) noSumIndex++;
				if(this.filters.showsite) noSumIndex++;
				if(noSumIndex<0) {
					this.filters.noShowColTable = true;
					noSumIndex++;
				}else{
					this.filters.noShowColTable = false;
				}
				//if(this.filters.showspTable) noSumIndex ++ ;
				//if(this.filters.showjslxTable) noSumIndex ++ ;
				//if(this.filters.showjszqTable) noSumIndex ++ ;
				//if(this.filters.showfeecodeTable) noSumIndex+=2;
				
				columns.forEach((column, index) => {
				  if (index <=noSumIndex) {
					return ;
				  }
				  if(index==noSumIndex+3||index==noSumIndex+6||index==noSumIndex+8){
					return ;
				  }
				  //////////////////////
				  const values = data.map(item => Number(item[column.property]));
				  if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
					  const value = Number(curr);
					  if (!isNaN(value)) {
						return prev + curr;
					  } else {
						return prev;
					  }
					}, 0);
				  } else {
					sums[index] = 'N/A';
				  }
				});
				if(noSumIndex>=0) sums[noSumIndex] = '合计';
				try{
					sums[noSumIndex+3] = (sums[noSumIndex+2]*100/sums[noSumIndex+1]).toFixed(2)+'%';
				}catch(e){}
				try{
					sums[noSumIndex+6] = (sums[noSumIndex+5]*100/sums[noSumIndex+4]).toFixed(2)+'%';
				}catch(e){}
				try{
					sums[noSumIndex+8] = ((sums[noSumIndex+9]-sums[noSumIndex+7]/100)*1000/sums[noSumIndex+4]).toFixed(2);
				}catch(e){}
				try{
					//sums[noSumIndex+7] = sums[noSumIndex+7].toFixed(2)+'';
					sums[noSumIndex+7] = '' ;
				}catch(e){}
				try{
					sums[noSumIndex+9] = sums[noSumIndex+9].toFixed(2)+'';
				}catch(e){}
				try{
					sums[noSumIndex+10] = sums[noSumIndex+10].toFixed(2)+'';
				}catch(e){}
				return sums;
			},
			actTimeQuery:function(){
				let para = {
					actionurl:'datas/refreshData'
				};
				getListPage(para).then((res) => {
					console.log(">>>!"+res.data);
					if(res.data.status == 200){
						console.log("会话激活!");
						//this.timer = setInterval(() => {
						//   setTimeout(this.actTimeQuery, 0)
						//}, 1000*60)
					}else{
						//失败
						console.log("会话过期!");
					}
				});
			}
		},
		mounted() {
			this.filters.entimes = util.formatDate.getdatestr(-1, 'yyyy-MM-dd');
			this.filters.entimee = util.formatDate.getdatestr(-1, 'yyyy-MM-dd');
			this.getServiceList();
			this.getLists();
			this.timer = setInterval(() => {
			   setTimeout(this.actTimeQuery, 0)
		    }, 1000*60);
		},
		beforeDestroy(){
			clearInterval(this.timer);        
			this.timer = null;
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// report.vue?64d168b6